import { render, staticRenderFns } from "./ReAccreditationGenerate.vue?vue&type=template&id=2cb45194&scoped=true&"
import script from "./ReAccreditationGenerate.vue?vue&type=script&lang=js&"
export * from "./ReAccreditationGenerate.vue?vue&type=script&lang=js&"
import style0 from "./ReAccreditationGenerate.vue?vue&type=style&index=0&id=2cb45194&scoped=true&lang=css&"
import style1 from "./ReAccreditationGenerate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb45194",
  null
  
)

export default component.exports